'use strict';
const _ = require('underscore');
module.exports = function freemindExport(idea) {
	const formatNode = function (idea) {
		const escapedText = escape(idea.title).replace(/%([0-9A-F][0-9A-F])/g, '&#x$1;').replace(/%u([0-9A-F][0-9A-F][0-9A-F][0-9A-F])/g, '&#x$1;');
		return '<node ID="' + idea.id + '" TEXT="' + escapedText + '">' + (_.size(idea.ideas) > 0 ? _.map(_.sortBy(idea.ideas, function (val, key) {
			return parseFloat(key);
		}), formatNode).join('') : '') + '</node>';
	};
	if (_.size(idea.ideas) === 1) {
		return '<map version="0.7.1">' + formatNode(_.values(idea.ideas)[0]) + '</map>';
	} else {
		return '<map version="0.7.1">' + formatNode(idea) + '</map>';
	}
};
